import {SearchPageType} from '../../search-config';
import {SearchPageAction} from '../../duck/search-types';
import {SavedSearchWithId} from './saveSearchComponent-types';
import {Dispatch, GetState} from '../../../app-types';
import {
    changeSavedSearchVisibility,
    deleteSavedSearch,
    deleteSavedSearchFolderOnTheContainer,
    fetchSavedSearches,
    postNewSavedSearch
} from './saveSearchComponent-service';
import {showError} from '../../../message-box/message-box-actions';
import {getSearchRequest} from '../../search.utils';

export function fetchSavedSearchesIfNeeded(searchPageType: SearchPageType) {
    return (dispatch: Dispatch, getState: GetState): any => {
        const container = getState().settings.containerName;
        fetchSavedSearches(searchPageType, container)
            .then((savedSearches) => dispatch(setSavedSearchHistory(searchPageType, savedSearches.own, savedSearches.shared_by_others)))
            .catch(() => dispatch(showError(searchPageType, 'search.saveSearch.action.errorLoad')));
    };
}

export function saveSearchItem(searchPageType: SearchPageType, savedSearchName: string, folder: string, shared: boolean) {
    return (dispatch: Dispatch, getState: GetState): void => {
        const searchRequest = getSearchRequest(searchPageType, getState);
        const savedSearch = {
            name: savedSearchName,
            folder: folder,
            shared: shared,
            request: {
                ...searchRequest,
                from: 0,
            }
        };
        postNewSavedSearch(searchPageType, savedSearch)
            .catch(() => dispatch(showError(searchPageType, 'search.saveSearch.action.errorSave')))
            .finally(() => dispatch(fetchSavedSearchesIfNeeded(SearchPageType.BASIC)));

    };
}

export function deleteSavedSearchItem(searchPageType: SearchPageType, savedSearchId: number) {
    return (dispatch: Dispatch, getState: GetState): void => {
        deleteSavedSearch(searchPageType, savedSearchId)
            .catch(() => dispatch(showError(searchPageType, 'search.saveSearch.action.errorDelete')))
            .finally(() => dispatch(fetchSavedSearchesIfNeeded(SearchPageType.BASIC)));
    };
}

export function deleteSavedSearchFolder(searchPageType: SearchPageType, savedSearchFolder: string) {
    return (dispatch: Dispatch, getState: GetState): void => {
        const body: DeleteSavedSearchFolderRequest = {
            folder: savedSearchFolder,
            container: getState().settings.containerName
        };

        deleteSavedSearchFolderOnTheContainer(searchPageType, body)
            .catch(() => dispatch(showError(searchPageType, 'search.saveSearch.action.errorDeleteFolder')))
            .finally(() => dispatch(fetchSavedSearchesIfNeeded(SearchPageType.BASIC)));
    };
}

export function shareSavedSearchItem(searchPageType: SearchPageType, savedSearchId: number, shared: boolean) {
    return (dispatch: Dispatch, getState: GetState): void => {
        changeSavedSearchVisibility(searchPageType, savedSearchId, {shared: shared})
            .catch(() => dispatch(showError(searchPageType, 'search.saveSearch.action.errorSaveVisibility')))
            .finally(() => dispatch(fetchSavedSearchesIfNeeded(SearchPageType.BASIC)));

    };
}


// ------------ Actions ------------
function setSavedSearchHistory(searchPageType: SearchPageType, savedSearches: SavedSearchWithId[], sharedByOthers: SavedSearchWithId[]): SearchPageAction {
    return {
        type: 'SEARCH_SET_SAVED_SEARCH_HISTORY',
        searchPageType: searchPageType,
        savedSearches: savedSearches,
        sharedByOthers: sharedByOthers,
    };
}

// --------------- Types ----------------
export type DeleteSavedSearchFolderRequest = {
    folder: string,
    container: string,
}
export type ShareSavedSearchFolderRequest = {
    shared: boolean,
}
